// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"4523d465","70":"60bcf79c","284":"d2882298","318":"8fec3da4","388":"3c15f6e0","401":"1d4c473d","440":"11eb426a","757":"cb9becdd","887":"d89c456f"}[chunkId] + ".chunk.js";
};